import { Component, Input, OnInit } from '@angular/core';
import { User } from '../../models/user';
import { UserService } from '../../services/user.service';
import { ApplicationRole } from '../../models/ApplicationRole';

@Component({
  selector: 'app-top-menu',
  standalone: false,
  templateUrl: './top-menu.component.html',
  styleUrl: './top-menu.component.less'
})
export class TopMenuComponent implements OnInit {
  currentUser!: User; // Accept currentUser data
  dataLoaded: boolean = false;
  canViewMyQueryReq: boolean = true;
  canViewPendingQueryReq: boolean = true;
  constructor(private userService: UserService) { }

  async ngOnInit(): Promise<void> {
    this.currentUser = this.userService.getCurrentUser(); // Get current user data from the service
    if (!this.currentUser?.User_Code) {
      this.userService.userUpdated.subscribe((user) => {
        this.currentUser = user;
        this.dataLoaded = true; // Set dataLoaded to true when user data is available
        this.setMenuVisibily(); // Call setMenuVisibily after data is loaded
      });
    }else {
      this.dataLoaded = true; // Set dataLoaded to true if currentUser is available
    }
  }
  setMenuVisibily() {
    if (this.currentUser.ApplicationRoles?.indexOf(ApplicationRole.RFCAdmin) !== -1
      || this.currentUser.ApplicationRoles.indexOf(ApplicationRole.DeptViewer) !== -1) {
      this.canViewMyQueryReq = false;
    }
    this.canViewPendingQueryReq = this.currentUser.ApplicationRoles?.indexOf(ApplicationRole.PartnerGeneralUser) === -1 
                               && this.currentUser.ApplicationRoles.indexOf(ApplicationRole.PartnerPowerUser) === -1;

    
  }
}
